export default class Question {
    constructor(map) {
        if (!map) {
            return;
        }

        this.id = map.get('questionId') || map.get('id') || '';
        this.order = map.get('orderNumber') || 1;
        this.type = map.get('questionType') || '';
        this.title = map.get('questionTitle') || '';
        this.sort = map.get('sortNumber') || '';
        this.optionId = Number.isNaN(map.get('optionId')) ? undefined : parseInt(map.get('optionId'), 10);
        this.comment = map.get('comment') || '';
        this.scaleId = map.get('scaleId');
    }
}
